import { render, staticRenderFns } from "./AddClients.vue?vue&type=template&id=d7988868&scoped=true&"
import script from "./AddClients.vue?vue&type=script&lang=js&"
export * from "./AddClients.vue?vue&type=script&lang=js&"
import style0 from "./AddClients.vue?vue&type=style&index=0&id=d7988868&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d7988868",
  null
  
)

export default component.exports